export default {"src":"/_next/static/media/question-mark-v2.2a9991e1.svg","height":32,"width":32};